module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/1-04f3569d3cc7ed04751f75378414f413.png";